<template>
    <div id="app" v-touch:right="onSwipeLeft">
        <router-view v-if="isRouterAlive"/>
    </div>
</template>

<script>
    import FloatingService from "@/components/FloatingService.vue";
    import {Dialog} from "vant";
    import Fetch from "./utils/fetch";

    export default {
        name: "App",
        components: {
            FloatingService,
        },
        provide() {
            return {
                reload: this.reload,
            };
        },
        data() {
            return {
                isRouterAlive: true,
                show_icon_type: "index",
                real_name: false,
                is_show_down_app: true,
                is_show_footer: true,
                sync_timer: null,
                app: {},
                f: localStorage.getItem("f") || "#00355A",
                isLogin: false,
            };
        },
        created() {
            this.checkLogin()
            // 监听登录/退出事件
            window.addEventListener('loginChange', this.checkLogin)
        },
        beforeDestroy() {
            window.removeEventListener('loginChange', this.checkLogin)
        },
        updated() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
        mounted() {
            // this.start();
        },
        methods: {
            checkLogin() {
                this.isLogin = !!localStorage.getItem('token')
            },
            reload() {
                this.isRouterAlive = false;
                this.$nextTick(function () {
                    this.isRouterAlive = true;
                });
                this.f = localStorage.getItem("f") || "#fff";
            },
            onSwipeLeft(even, start, end) {
                console.log();
                // if (end["X"] - start["X"] > 60) {
                //     this.$router.go(-1);
                // }
            },
            bigNumeber(str) {
                str = str.toString();
                var strs = str.split(".");
                var s1 = strs[0] || 0;
                var s2 = strs[1] || "00";
                return `<span class="bigNum">${s1}</span><span>.</span><span>${s2}</span>`;
            },
            numFilter(value) {
                let transformVal = parseFloat(value).toFixed(3);
                let realVal = transformVal.substring(0, transformVal.length - 1);
                return parseFloat(realVal);
            },
            footer: function (type = "index", show_footer = true) {
                if (type == "walfare") {
                    document.getElementById("app").style.paddingBottom = "0";
                } else {
                    document.getElementById("app").style.paddingBottom = "0";
                }
                this.show_icon_type = type;
                this.is_show_footer = show_footer;
            },
            // start() {
            //     Fetch("/index/webconfig").then((r) => {
            //         this.app = r.data;
            //         this.$store.commit('setConfig', {
            //             data: {
            //                 kefu_link: r.data.kefu_link,
            //                 whatsapp: r.data.whatsapp,
            //                 app_link: r.data.app_link,
            //                 tg: r.data.tg,
            //             }
            //         })
            //         // window.document.title = r.data.title;
            //     });
            //
            //     this.sync_timer = setInterval(() => {
            //         this.sync();
            //     }, 3000);
            // },
            closeDownApp() {
                this.is_show_down_app = false;
            },
            sync() {
                /* Fetch("/index/sync", {}, null, false).then((r) => {
                               if (r.data.is_open_notice_dialog) {
                                   this.openNoticeDialog();
                               }
                           }); */
            },
            close() {
                this.show_anwser = false;
            },
            openNoticeDialog() {
                Dialog.confirm({
                    title: "提示",
                    message: "您有新消息，是否前往查看?",
                })
                    .then(() => {
                        this.$router.push("/notice");
                    })
                    .catch(() => {
                    });
            },
        },
    };
</script>
<style lang="less">
    .flex-p {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .flex-f {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    // @import "./assets/font/font.css";
    .kefu {
        width: 80px;
        height: 80px;
        position: fixed;
        right: 13px;
        bottom: 50px;
        transition: all 1s;
        opacity: 1;
        transform: translateX(0);
        z-index: 80;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .kefu.kefu_hide {
        transform: translateX(70%);
        opacity: 0.5;
    }

    .numberFont {
        font-family: barlow !important;
        font-size: 15px !important;
        font-weight: bold !important;

        span:nth-of-type(3) {
            font-size: 14px !important;
        }

        span:nth-of-type(4) {
            font-size: 12px !important;
        }
    }

    html,
    body {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
    }

    html::-webkit-scrollbar,
    body::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }

    body {
        margin: 0;
    }

    .bigNum {
        font-size: 18px !important;
    }

    .fh {
        font-size: 12px !important;
    }

    .larfont .fh {
        margin-top: 3px;
    }

    .wan {
        font-size: 14px;
        margin-top: 2px;
    }

    .numberFontBold {
        span:first-child {
            font-size: 12px;
            margin-top: 4px;
        }

        span:last-child {
            margin-top: 2px;
        }
    }

    .top-page {
        position: relative;
        z-index: 9;
        height: 100vh;
        background-color: #fff;
        overflow-y: auto;
    }


    #app .download_box {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        position: fixed;
        margin: 0 auto;
        left: 0;
        right: 0;
        height: 45px;
        width: 100%;
        max-width: 375px;
        background: rgba(0, 0, 0, 0.5);
        bottom: 50px;
        padding: 0 3.6%;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        z-index: 10;
    }

    #app .download_box .down {
        -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding-right: 10px;
    }

    #app .download_box .down .down_left {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    #app .download_box .down .down_left .app_logo {
        display: inline-block;
        width: 40px;
        height: 40px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        background-image: url(./views/images/home/app_logo.svg);
        margin-right: 14px;
    }

    #app .download_box .down .down_left .app_info {
        font-size: 12px;
        color: #fff;
        line-height: 1.5;
    }

    #app .download_box .down .right {
        background: #d8232c;
        padding: 5px 5px;
        color: #ffffff;
        border-radius: 5px;
        font-size: 12px;
    }

    #app .download_box .close_down {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 20px;
        flex: 0 0 20px;
        height: 45px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        background-image: url(./views/images/home/close.svg);
    }



    .middle-bg {
        width: 60px;
        height: 28px;
        border-top: 1px solid #e5e5e5;
        border-radius: 30px 30px 0 0;
        background: #fff;
        position: absolute;
        z-index: -1;
        top: -20px;
    }


    .red_top_bg {
        width: 100%;
        max-width: 750px;
        height: 44px;
        margin: 0 auto;
        background: #f9fafb;
        background-size: 100% 100%;
        overflow: hidden;
        display: flex;
        align-items: center;
        /*border-bottom: 1px solid rgba(0,0,0,.16);*/
    }

    .top_right {
        position: absolute;
        font-size: 14px;
        line-height: 18px;
        color: #ffffff;
        top: 13px;
        right: 14px;
    }

    .limit {
        height: 20px;
        line-height: 20px;
        border-radius: 10px;
        background: rgba(241, 34, 17, 0.08);
        color: #f12211;
        text-align: center;
        padding: 0 7px;
        border: 1px solid #f12211;
        font-size: 12px;
    }

    .gray_btn {
        height: 20px;
        display: flex;
        align-items: center;
        background: rgba(0, 0, 0, 0.3);
        font-size: 12px;
        text-align: center;
        color: #ffffff;
        border-radius: 10px;
        padding: 0 9px;
    }

    .big_tit {
        position: absolute;
        /*height: 25px;*/
        font-size: 18px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        /*line-height: 25px;*/
        /*top: 12px;*/
        left: 50%;
        transform: translateX(-50%);
        /*flex: 1;*/
        /*text-align: center;*/
    }

    .red_top_bg .detail {
        margin-left: auto; /* 强制靠右 */
        margin-right: 8px;
    }

    .sub_btn {
        background: linear-gradient(123deg, #e3382e, #ff4d15);
        height: 36px;
        line-height: 36px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        width: 94px;
        border-radius: 18px;
    }

    .remove_btn {
        background: linear-gradient(117deg,
        rgba(254, 166, 0, 1) 0%,
        rgba(255, 188, 0, 1) 100%);
        height: 36px;
        line-height: 36px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        width: 94px;
        border-radius: 18px;
    }

    .home_tit {
        width: 100%;
        height: 22px;
        line-height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;

        .line {
            width: 75px;
            height: 2px;
        }

        h5 {
            font-size: 16px;
            line-height: 22px;
            color: #000000;
            margin: 0 10px;
            font-weight: bold;
        }
    }

    .van-popup {
        max-width: 100%;
        margin: 0 auto;
        right: 0;
    }

    .back_left {
        position: absolute;
        width: 20px;
        height: 20px;
        background: url(./views/images/item/back.png) no-repeat center center;
        background-size: auto 100%;
        margin: 0px 0 0 8px;
    }

    .basic_btn {
        height: 45px;
        line-height: 45px;
        font-size: 16px;
        font-weight: 700;
        width: 90%;
        background: #0590c8;
        border-radius: 0px;
        color: #fff;
        text-align: center;
    }

    .basic_btn.no_touch {
        color: rgba(255, 255, 255, 0.5);
    }

    .flex_center {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .wrap_box {
        width: 100%;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
        border-radius: 6px;
    }

    .eye_bi {
        width: 21px;
        height: 25px;
        background: url(./views/images/user/eye2.png) no-repeat center center;
        background-size: 100% auto;

        &.eye {
            background: url(./views/images/user/eye1.png) no-repeat center center;
            background-size: 100% auto;
        }
    }

    .real_name_mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 30;
        background-color: rgba(0, 0, 0, 0.95);

        .real_box {
            width: 272px;
            height: 185px;
            background: rgba(255, 255, 255, 1);
            border-radius: 8px;
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            margin: -92px auto 0 auto;

            .tit {
                width: 77px;
                height: 67px;
                position: absolute;
                top: -35px;
                left: 50%;
                transform: translateX(-50%);
                background: url("~@/assets/images/wallet1.svg") no-repeat center center;
                background-size: 100% 100%;
            }

            .tips {
                width: 185px;
                height: 50px;
                text-align: center;
                font-size: 18px;
                color: #000000;
                line-height: 25px;
                position: absolute;
                top: 49px;
                left: 50%;
                transform: translateX(-50%);
            }

            .basic_btn {
                width: 225px;
                position: absolute;
                left: 0;
                right: 0;
                margin: 0 auto;
                bottom: 15px;
            }
        }
    }

    .contract_box img {
        width: 100%;
    }

    .yhjjiejue .van-coupon-list__empty p {
        font-size: 0 !important;
    }

    .yhjjiejue .van-coupon-list__empty p::before {
        display: block !important;
        content: '' !important;
        font-size: 14px !important;
        margin: 16px 0;
        color: #969799;
        line-height: 20px;
    }
    .cust .van-tabs {
        margin-top: -1px;
    }
    .cust .van-tabs__line {
        background-color: #76b900!important;
    }
    .cust .van-tabs__nav {
        background-color: #1a1a1a!important;
    }
    .cust .van-tab {
        color: #fff!important;
    }
    .cust .van-tab--active {
        font-weight: bold!important;
    }
    .custom_cell .van-cell {
        padding:0 2px;
    }

    .cust2 .van-tabs {
        margin-top: -1px;
    }
    .cust2 .van-tabs__line {
        background-color: #76b900!important;
    }
    .cust2 .van-tabs__nav {
        background-color: #99c999 !important;
    }
    .cust2 .van-tab {
        color: #fff!important;
    }
    .cust2 .van-tab--active {
        font-weight: bold!important;
    }

    .red_top_bg .van-dropdown-menu {
        background-color: transparent !important; // 背景透明
        box-shadow: none !important;             // 去掉阴影
        border: none !important;                 // 去掉边框
    }

    .red_top_bg .van-dropdown-menu__bar {
        background-color: transparent !important; // 背景透明
    }

    .red_top_bg .van-dropdown-menu__title {
        color: #fff; // 标题文字改成白色，和背景对比
    }

    .red_top_bg .van-dropdown-item__content {
        background-color: transparent !important; // 打开下拉选项时内容背景透明
        color: #fff;                              // 文字白色
    }
    .custom-btn {
        background-color: #0590c8!important;
        color: #fff!important;
    }

    /* 基础文本元素 */
    p, li, span, div, td, th, label, a, strong, em, b, i, u, s, mark, small, sub, sup, code, kbd, samp, var, cite, dfn, abbr, time, data, q, blockquote, pre, address {
        word-break: break-word !important;
        overflow-wrap: break-word !important;
        hyphens: auto !important; /* 添加自动断字 */
    }

    /* 标题元素 */
    h1, h2, h3, h4, h5, h6 {
        word-break: break-word !important;
        overflow-wrap: break-word !important;
        hyphens: auto !important;
    }

    /* 表单元素和特殊内容 */
    input, textarea, button, select, option, legend, figcaption, caption, summary, dt, dd {
        word-break: break-word !important;
        overflow-wrap: break-word !important;
    }
</style>
